import Vue from 'vue';

Vue.filter(
    'CkEditor', value => {
        var CkEditor = value.replaceAll("&lt;", "<");
        var CkEditor_done = CkEditor.replaceAll("&gt;", ">");
        return CkEditor_done;
    }
);

Vue.filter(
    'upperCase', value => {
        return value.toUpperCase();
    }
);

Vue.filter(
    'lowerCase', value => {
        return value.toLowerCase();
    }
);
Vue.filter(
    'lowerCase', value => {
        return value.toLowerCase();
    }
);

Vue.filter(
    'DateTime', value => {
        if (value != '') {
            return moment(value).format("YYYY/MM/DD - HH:mm");
        } else {
            return value
        }
    }
);

Vue.filter(
    'Time', value => {
        return moment(value).format("HH:mm");
    }
);

Vue.filter(
    'Hour', value => {
        return moment(value).format("HH");
    }
);

Vue.filter('rupiah', function (value) {
    if (typeof value === 'undefined') {
        return value;
    }
    var number_string = value.toString(),
        sisa = number_string.length % 3,
        rupiah = number_string.substr(0, sisa),
        ribuan = number_string.substr(sisa).match(/\d{3}/g);

    if (ribuan) {
        var separator = sisa ? "." : "";
        rupiah += separator + ribuan.join(".");
    }

    return rupiah ? "Rp. " + rupiah : "";
});

Vue.filter(
    'DateTimes', value => {
        if (value != '') {
            return moment(value).format("YYYY/MM/DD - HH:mm:ss");
        } else {
            return value
        }
    }
);

Vue.filter(
    'DateTimeV2', value => {
        if (value != '') {
            return moment(value).format("DD-MM-YYYY HH:mm:ss");
        } else {
            return value
        }
    }
);

Vue.filter(
    'DateTimeV3', value => {
        if (value != '') {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
        } else {
            return value
        }
    }
);

Vue.filter(
    'DateTimeV4', value => {
        if (value != '') {
            return moment(value).format("DD/MM/YYYY HH:mm");
        } else {
            return value
        }
    }
);

Vue.filter('percentage_symbol', function (value) {
    if (typeof value === 'undefined') {
        return value;
    }
    var number_string = value.toString(),
        sisa = number_string.length % 3,
        percentage = number_string.substr(0, sisa),
        ribuan = number_string.substr(sisa).match(/\d{3}/g);

    if (ribuan) {
        var separator = sisa ? "." : "";
        percentage += separator + ribuan.join(".");
    }
    return percentage ? percentage + " %" : "";
});

Vue.filter(
    'remove_underscore', value => {
        return value.replaceAll("_", " ");
    }
);